export const homePageData = [
  {
    src: 'https://ik.imagekit.io/excellenceclasses/HealthOnHands/marc-zeman-uLWW09LLG04-unsplash_9yaV9jSHG.jpg?updatedAt=1741253548288' ,
    heading: ['Health On Hands'],
    body: 'Healing through hands-on care.',
    animation: ''
  }
];